module.exports = __webpack_public_path__ + "img/import.cc5f482d.svg";